import React from "react";

const Impressum = () => {
  return (
    <>
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUquDBuUUY-j9ALBIXGNogl9Nhe3LgG5MIlIMPk_BV0k);ol{margin:0;padding:0}table td,table th{padding:0}.c3{background-color:#ffffff;-webkit-text-decoration-skip:none;color:#0563c1;font-weight:400;text-decoration:underline;text-decoration-skip-ink:none;font-size:10.5pt;font-family:"Open Sans"}.c4{background-color:#ffffff;color:#333333;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Calibri";font-style:normal}.c10{background-color:#ffffff;padding-top:0pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c8{color:#333333;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Calibri";font-style:normal}.c9{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:14pt;font-family:"Calibri";font-style:normal}.c0{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left;height:12pt}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Calibri";font-style:normal}.c2{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Calibri";font-style:normal}.c5{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c6{background-color:#ffffff;font-size:10.5pt;font-family:"Open Sans";color:#171717;font-weight:400}.c7{background-color:#ffffff;max-width:451.3pt;padding:72pt 72pt 72pt 72pt}.c12{color:inherit;text-decoration:inherit}.c11{background-color:#ffffff;color:#333333}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.0;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:12pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:12pt;font-family:"Calibri"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:0pt;color:#000000;font-weight:700;font-size:13.5pt;padding-bottom:0pt;font-family:"Times New Roman";line-height:1.0;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}'
        }}
      />
      <p className="c5">
        <span className="c9">Arbopark Promotion AG Impressum</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c5">
        <span className="c2">Adresse</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c5">
        <span className="c1">Arbopark Promotion AG</span>
      </p>
      <p className="c5">
        <span className="c1">Stegackerstrasse 6</span>
      </p>
      <p className="c5">
        <span className="c1">8409 Winterthur</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c5">
        <span className="c2">Kontakt</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c5">
        <span className="c1">Telefon: 071 552 80 00</span>
      </p>
      <p className="c5">
        <span className="c1">E-mail: info@arbopark.ch</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c10">
        <span className="c8">Wirtschaftsinformationen</span>
      </p>
      <p className="c5">
        <span className="c4">Geschäftsführer: Jonas Blechschmid</span>
      </p>
      <p className="c0">
        <span className="c4" />
      </p>
      <p className="c5">
        <span className="c11">Handelsregister:</span>
        <span>&nbsp;</span>
        <span className="c6">CH-020.3.047.931-3 (</span>
        <span className="c3">
      <a
        className="c12"
        href="https://www.google.com/url?q=https://www.zefix.admin.ch/en/search/entity/list/firm/1411247&sa=D&source=editors&ust=1705999404881967&usg=AOvVaw0wWmt3RgyrBHeLDQcBckdo"
      >
        Auszug
      </a>
    </span>
        <span className="c6">)</span>
      </p>
      <p className="c5">
        <span className="c11">MWSt-Nummer:&nbsp;</span>
        <span className="c6">CHE-276.851.534 MWST</span>
      </p>
      <p className="c5">
        <span className="c11">Firmensitz: 8409 Winterthur</span>
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
      <p className="c0">
        <span className="c1" />
      </p>
    </>


  );
};

export default Impressum;